
import { LayoutTypeFacet } from '../../models/layouts/LayoutTypeFacet';

export const detailsLayoutType = new LayoutTypeFacet('details');

export const compactDetailsLayoutType = new LayoutTypeFacet('compactDetails');
